import React from 'react'
import CardFeeds from 'src/app/CardFeeds/CardFeeds'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { cardFeedsRouteProps } from 'src/navigation/routeProps'

const CardFeedsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsCardFeeds,
  routeProps: cardFeedsRouteProps,
  component: <CardFeeds />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default CardFeedsAppRoute
